import { Box, Collapse, Divider, Flex } from "@chakra-ui/react";
import * as React from "react";

type HiddenSectionProps = {
  show: boolean;
  showIndent?: boolean;
  children: React.ReactNode;
};

export const HiddenSection = ({
  show,
  showIndent = true,
  children,
}: HiddenSectionProps) => {
  return (
    <Collapse in={show} unmountOnExit={true}>
      <Flex>
        {showIndent && (
          <Divider
            orientation="vertical"
            borderWidth="2px"
            borderColor="brand.orange"
            height="auto"
            mx={6}
          />
        )}
        <Box width="100%">{children}</Box>
      </Flex>
    </Collapse>
  );
};
